import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { State } from '../../types/StateType'
import { PatientAlertConfiguration } from './types'

const patientAlertConfigurationAdapter =
  createEntityAdapter<PatientAlertConfiguration>({
    selectId: (patientAlertConfiguration) =>
      patientAlertConfiguration.patientKey,
  })

let definedProps: { error: any; loading: boolean; success: any } = {
  error: null,
  loading: false,
  success: null,
}

const initialState =
  patientAlertConfigurationAdapter.getInitialState(definedProps)

const patientAlertConfigurationSlice = createSlice({
  name: 'patientAlertConfiguration',
  initialState: initialState,
  reducers: {
    getPatientAlertConfiguration: (state, action: PayloadAction<string>) => {
      state.loading = true
    },
    addPatientAlertConfiguration: (
      state,
      action: PayloadAction<PatientAlertConfiguration>
    ) => {
      state.loading = false
      patientAlertConfigurationAdapter.upsertOne(state, action.payload)
    },
    addPatientAlertConfigurationSuccess: (
      state,
      action: PayloadAction<PatientAlertConfiguration>
    ) => {
      state.loading = false
      patientAlertConfigurationAdapter.addOne(state, action.payload)
    },
    errorPatientAlertConfiguration: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.error = action.payload
    },
    successPatientAlertConfiguration: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.success = action.payload
    },
  },
})

export const {
  addPatientAlertConfiguration,
  addPatientAlertConfigurationSuccess,
  errorPatientAlertConfiguration,
  getPatientAlertConfiguration,
  successPatientAlertConfiguration,
} = patientAlertConfigurationSlice.actions

export default patientAlertConfigurationSlice.reducer

const { selectById } = patientAlertConfigurationAdapter.getSelectors()

export const selectPatientAlertConfigurationByKey = (key: string) =>
  createSelector(
    (state: State) => state.patientAlertConfiguration,
    (patientAlertConfiguration) =>
      selectById(patientAlertConfiguration, key)?.alertConfiguration
  )

export const selectErrorInPatientAlertConfiguration = createSelector(
  (state: State) => state.patientAlertConfiguration.error,
  (error) => error
)
export const selectSuccessInPatientAlertConfiguration = createSelector(
  (state: State) => state.patientAlertConfiguration.success,
  (success) => success
)
